module.exports = __webpack_public_path__ + "img/taxation.4d0471ba.png";